import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import * as healthDataReducers from '../../health-data/reducer';
import * as reducers from '../reducer/ReportDialog';
import * as errorReportReducers from '../reducer';

import * as errorReportActionMgr from '../aciton-mgr';
import * as actionMgr from '../aciton-mgr/ReportDialog';

import * as strings from '../../helpers/strings';

import { getUserId } from '../../helpers/common';

const styles = {
  dialogContent: {
    width: '600px', 
    height: '300px', 
    padding: '20px', 
  },
};

class ReportDialog extends Component{
  constructor(){
    super();

    this.handleCancel = this.handleCancel.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
  }

  handleCancel = () => {
    const { toggleMessageDialog, setMessage } = this.props;
    setMessage("");
    toggleMessageDialog();
  }

  handleSend = () => {
    const { submitErrorReport, stationHealth, message, toggleMessageDialog } = this.props;
    submitErrorReport({
      errorType: stationHealth.errorType,
      message,
      userId: getUserId(),
      stationName: stationHealth.stationId
    });
    toggleMessageDialog();
  }

  handleMessageChange = e => this.props.setMessage(e.target.value);

  render = () => {
    const { classes, stationHealth, openedDialog, errorTypes, message, snackBarMessage, openedSnackBar, closeSnackBar, isSaving } = this.props;

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={openedSnackBar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{snackBarMessage }</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={closeSnackBar}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
        {stationHealth && 
          <Dialog
            disableBackdropClick={true}
            open={openedDialog}
            onClose={this.handleCancel}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">{stationHealth.stationId} - {errorTypes[stationHealth.errorType.toString()] || "..."}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <TextField
                autoFocus
                margin={strings.txtNormal}
                label={strings.lblMessage}
                value={message}
                onChange={this.handleMessageChange}
                multiline
                rows={4}
                rowsMax={10}
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCancel} color={strings.colorPrimary}>{strings.lblCancel}</Button>
              <Button onClick={this.handleSend} color={strings.colorPrimary} disabled={!message || isSaving}>{strings.lblSubmit}</Button>
            </DialogActions>
          </Dialog>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  message: reducers.getMessage(state),
  snackBarMessage: reducers.getSnackBarMessage(state),
  openedSnackBar: reducers.getOpenedSnackBar(state),
  openedDialog: reducers.getOpenedDialog(state),

  stationHealth: healthDataReducers.getSelectedStationHealth(state),
  errorTypes: healthDataReducers.getErrorTypes(state),

  isSaving: errorReportReducers.getIsSaving(state)
});

export default connect(mapStateToProps, {
  setMessage: actionMgr.setMessage,
  closeSnackBar: actionMgr.closeSnackBar,
  toggleMessageDialog: actionMgr.toggleMessageDialog,
  
  submitErrorReport: errorReportActionMgr.submitErrorReport
})(
  withStyles(styles)(ReportDialog)
);